module.exports = __webpack_public_path__ + "static/media/error.b1100ff0.svg";